import go from '@/gojs/go'

import assert from '@/sui/tools/assert'
import ice from '@/sui/tools/ice'
import checker from '@/sui/tools/checker'
import clone from 'clone'
import color from 'color'
import units from '@/sui/data/units'
import css from '@/sui/less/modules.less'
import math from '@/sui/tools/math'

const infectionTypes = [
  {
    name: `Bactériémies acquises dans l'établissement`,
    shortName: `Bactériémies`,
    code: 'bact',
    subtitle: `bactériémies acquises dans l'établissement`
  },
  {
    name: `Pneumopathies`,
    shortName: `Pneumopathies`,
    code: 'pneu',
    subtitle: `pneumopathies`
  }
]

const jh = {
  label: `1000 journées d'hospitalisation (ancien taux)`,
  short: `1000 JH`,
  unit: `journées d'hospitalisation complètes`
}

const jhc = {
  label: `1000 journées d'hospitalisation complètes`,
  short: `1000 JHC`,
  unit: `jhc`
}

const jhi = {
  label: `1000 journées d'hospitalisation incomplètes`,
  short: `1000 JHI`,
  unit: `journées d'hospitalisation incomplètes`
}

const kt = {
  label: `1000 journées cathéter`,
  short: `1000 jours KT`,
  unit: `journées cathéter`
}

const adm = {
  label: `100 admissions`,
  short: `100 admissions`,
  unit: `admissions`
}

const pat = {
  label: `100 patients exposés`,
  short: `100 patients exposés`,
  unit: `patients exposés`
}

const chi = {
  label: `1000 séances de chimiothérapie`,
  short: `1000 chimiothérapie`,
  unit: `séances de chimiothérapie`,
  year: 2021
}

const ga1 = {
  label: `100 patients nés avant 28 SA`,
  short: `100 patients (<28 SA)`,
  unit: `patients nés avant 28 SA`,
  year: 2020
}

const ga2 = {
  label: `100 patients nés entre 28 et 32 SA`,
  short: `100 patients (28 à 32 SA)`,
  unit: `patients nés entre 28 et 32 SA`,
  year: 2020
}

const ga3 = {
  label: `100 patients nés entre 33 et 37 SA`,
  short: `100 patients (33 à 37 SA)`,
  unit: `patients nés entre 33 et 37 SA`,
  year: 2020
}

const ga4 = {
  label: `100 patients nés après 37 SA`,
  short: `100 patients (> 37 SA)`,
  unit: `patients nés après 37 SA`,
  year: 2020
}

const bw1 = {
  label: `100 patients au poids de naissance <= 750g`,
  short: `100 patients (<= 750g)`,
  unit: `patients au poids de naissance <= 750g`,
  year: 2020
}

const bw2 = {
  label: `100 patients au poids de naissance entre 751g et 1000g`,
  short: `100 patients (751g à 1000g)`,
  unit: `patients au poids de naissance entre 751g et 1000g`,
  year: 2020
}

const bw1Bw2 = {
  label: `100 patients au poids de naissance <= 1000g`,
  short: `100 patients (<= 1000g)`,
  unit: `patients au poids de naissance <= 1000g`,
  year: 2020
}

const bw3 = {
  label: `100 patients au poids de naissance entre 1001g et 1500g`,
  short: `100 patients (1001g à 1500g)`,
  unit: `patients au poids de naissance entre 1001g et 1500g`,
  year: 2020
}

const bw1Bw2Bw3 = {
  label: `100 patients au poids de naissance <= 1500g`,
  short: `100 patients (<= 1500g)`,
  unit: `patients au poids de naissance <= 1500g`,
  year: 2020
}

const bw4 = {
  label: `100 patients au poids de naissance entre 1501g et 2500g`,
  short: `100 patients (1501g à 2500g)`,
  unit: `patients au poids de naissance entre 1501g et 2500g`,
  year: 2020
}
const bw5 = {
  label: `100 patients au poids de naissance > 2500g`,
  short: `100 patients (> 2500g)`,
  unit: `patients au poids de naissance > 2500g`,
  year: 2020
}
const igsPneu1 = {
  label: `100 patients avec igsII entre 0 et 35 (Rezo PAVM classe 1)`,
  short: `100 patients (igsII 0 à 35)`,
  unit: `patients avec igsII entre 0 et 35 (Rezo PAVM classe 1)`,
  hidden: true
}
const igsPneu2 = {
  label: `100 patients avec igsII entre 36 et 47 (Rezo PAVM classe 2)`,
  short: `100 patients (igsII 36 à 47)`,
  unit: `patients avec igsII entre 36 et 47 (Rezo PAVM classe 2)`,
  hidden: true
}
const igsPneu3 = {
  label: `100 patients avec igsII entre 48 et 61 (Rezo PAVM classe 3)`,
  short: `100 patients (igsII 48 à 61)`,
  unit: `patients avec igsII entre 48 et 61 (Rezo PAVM classe 3)`,
  hidden: true
}
const igsPneu4 = {
  label: `100 patients avec igsII >= 62 (Rezo PAVM classe 4)`,
  short: `100 patients (igsII >= 62)`,
  unit: `patients avec igsII >= 62 (Rezo PAVM classe 4)`,
  hidden: true
}
const igsBact1 = {
  label: `100 patients avec igsII entre 0 et 34 (Rezo BACT classe 1)`,
  short: `100 patients (igsII 0 à 34)`,
  unit: `patients avec igsII entre 0 et 34 (Rezo BACT classe 1)`,
  hidden: true
}
const igsBact2 = {
  label: `100 patients avec score igsII entre 35 et 46 (Rezo BACT classe 2)`,
  short: `100 patients (igsII 35 à 46)`,
  unit: `patients avec score igsII entre 35 et 46 (Rezo BACT classe 2)`,
  hidden: true
}
const igsBact3 = {
  label: `100 patients avec score igsII entre 47 et 59 (REZO BACT classe 3)`,
  short: `100 patients (igsII 47 à 59)`,
  unit: `patients avec score igsII entre 47 et 59 (REZO BACT classe 3)`,
  hidden: true
}
const igsBact4 = {
  label: `100 patients avec score igsII >= 60 (REZO BACT classe 4)`,
  short: `100 patients (igsII >= 60)`,
  unit: `patients avec score igsII >= 60 (REZO BACT classe 4)`,
  hidden: true
}

const ktTypeData = {
  1: {
    title: 'Incidence des bactériémies liées à un cathéter central',
    style: 'p2'
  },
  2: {
    title: 'Incidence des bactériémies liées à un cathéter veineux périphérique court',
    style: 'b2'
  }
}

function getktTypeData (t) {
  return ktTypeData[t]
}

const establishments = {
  'CHRU/CHR/HA': {
    title: 'CHU / CHR / HA',
    values: [1, 4]
  },

  'CH': {
    title: 'CH',
    values: [2]
  },

  'MCO': {
    title: 'MCO',
    values: [6]
  },

  'CLCC': {
    title: 'CLCC',
    values: [5]
  },

  'HAD': {
    title: 'HAD',
    values: [10]
  },

  'HL': {
    title: 'HL',
    values: [3]
  },

  'SSR': {
    title: 'SSR',
    values: [7]
  },

  'PSY': {
    title: 'PSY',
    values: [9]
  },

  'EHP/SLD': {
    title: 'EHP / SLD',
    values: [8, 12]
  },

  'DIA': {
    title: 'DIA',
    values: [11]
  },

  'TOUS': {
    title: 'TOUS',
    graphTitle: 'pour tous les établissements',
    values: []
  },

  'MATER1': {
    title: 'MATER T1',
    maternityType: 1,
    values: []
  },

  'MATER2A': {
    title: 'MATER T2A',
    maternityType: 2,
    values: []
  },

  'MATER2B': {
    title: 'MATER T2B',
    maternityType: 3,
    values: []
  },

  'MATER3': {
    title: 'MATER T3',
    maternityType: 4,
    values: []
  }
}

const qualities = [
  {
    color: css.bactADI,
    opacity: 1,
    tooltip: 'Bon élève'
  },
  {
    color: css.alone,
    opacity: 0.7,
    tooltip: 'Tout seul'
  },
  {
    color: css.expADI,
    opacity: 1,
    tooltip: 'Outlier'
  },
  {
    color: css.invalid,
    opacity: 0.4,
    tooltip: 'Valeur peu vraisemblante'
  },
  {
    color: css.temporary,
    opacity: 1,
    tooltip: 'Valeur provisoire'
  },
  {
    color: css.incomplete,
    opacity: 0.5,
    tooltip: 'Valeur partielle'
  }
]

const denominators = {
  bact: {
    kt: kt,
    jhc: jhc,
    jhi: jhi,
    sea: {
      label: `1000 séances de dialyse`,
      short: `1000 séances`,
      unit: `séances de dialyse`
    },
    adm: adm,
    pat: pat,
    chi: chi,
    jh: jh,
    ga1: ga1,
    ga2: ga2,
    ga3: ga3,
    ga4: ga4,
    bw1: bw1,
    bw2: bw2,
    'bw1-bw2': bw1Bw2,
    bw3: bw3,
    'bw1-bw2-bw3': bw1Bw2Bw3,
    bw4: bw4,
    bw5: bw5,
    igsBact1: igsBact1,
    igsBact2: igsBact2,
    igsBact3: igsBact3,
    igsBact4: igsBact4
  },

  pneu: {
    ji: {
      label: `1000 journées d'intubation`,
      short: `1000 j-intubation`,
      unit: `journées d'intubation`
    },
    jhc: jhc,
    jhi: jhi,
    adm: adm,
    pat: pat,
    jh: jh,
    igsPneu1: igsPneu1,
    igsPneu2: igsPneu2,
    igsPneu3: igsPneu3,
    igsPneu4: igsPneu4
  }
}

function extractDenominators () {
  const result = {}
  const all = {}
  for (let t in denominators) {
    const type = denominators[t]
    result[t] = []
    for (let d in type) {
      if (all[d] == null) {
        all[d] = {
          code: d,
          info: type[d]
        }
      }
      result[t].push(all[d])
    }
  }

  return result
}

const extractedDen = extractDenominators()

const entrances = {
  bact: {
    all: {
      title: `Toutes portes d'entrée`,
      tooltip: `Toutes les portes d'entrée (incluant les portes d'entrée non retrouvées)`,
      short: 'Toutes PE'
    },
    ctr: {
      title: `Cathéters centraux et apparentés`,
      short: 'Cathéters centraux et apparentés',
      tooltip: `CVC, CCI, CVO, PICC, cathéter artériel, CAO, ECMO et autres cathéters centraux`
    },
    peri: {
      title: `CVP court et MIDline`,
      tooltip: `CVP court et MIDline`,
      short: 'CVP court et MIDline'
    },
    dia: {
      title: `Sites d'accès vasculaire de Dialyse`,
      tooltip: `Cathéter de dialyse, fistule native et fistule prothèse`,
      short: `Sites d'accès vasculaire de Dialyse`
    },
    cvc: {
      title: 'CVC'
    },
    cci: {
      title: 'CCI'
    },
    cvo: {
      title: 'CVO'
    },
    picc: {
      title: 'PICC'
    },
    cart: {
      title: 'Cathéter Artériel',
      year: 2020
    },
    ecmo: {
      title: 'ECMO',
      year: 2020
    },
    cao: {
      title: 'Cathéter Artériel Ombilical',
      year: 2021
    },
    caut: {
      title: 'Autres cathéters centraux',
      short: 'Autres KT centraux'
    },
    mid: {
      title: 'MIDline',
      tooltip: 'MIDline (avec et sans prolongateur intégré ou statut du prolongateur non connu)'
    },
    midap: {
      title: 'MIDline avec PI',
      year: 2020
    },
    midsp: {
      title: 'MIDline sans PI',
      year: 2020
    },
    cvp: {
      title: 'CVP court',
      tooltip: 'CVP court (avec et sans prolongateur intégré ou statut du prolongateur non connu)'
    },
    cvpap: {
      title: 'CVP court avec PI',
      year: 2020
    },
    cvpsp: {
      title: 'CVP court sans PI',
      year: 2020
    },
    cdia: {
      title: 'Cathéter de dialyse',
      short: 'Cathéter dialyse'
    },
    fistnat: {
      title: 'Fistule native',
      short: 'Fistule native'
    },
    fistpro: {
      title: 'Fistule prothèse',
      short: 'Fistule prothèse'
    },
    uri: {
      title: 'Urinaire',
      year: 2020
    },
    urisa: {
      title: 'Urinaire avec antécédent de sondage (7j)',
      year: 2020
    },
    nf: {
      title: 'PE non retrouvée',
      year: 2020
    },
    nfctr: {
      title: 'PE non retrouvée avec cathéter central ou apparenté',
      year: 2020
    },
    nfperi: {
      title: 'PE non retrouvée avec CVP court ou MIDline',
      year: 2020
    },
    sta: {
      title: 'S. aureus sur toutes les PE',
      tooltip: `<i>Staphylococcus aureus</i> sur toutes les portes d'entrée (incluant les portes d'entrée non retrouvées)`,
      year: 2020
    },
    stakt: {
      title: 'S. aureus sur cathéter',
      tooltip: `<i>Staphylococcus aureus</i> sur porte d'entrée C1 à C14 et D1`,
      year: 2020
    },

    'in-ctr': {
      title: 'Indicateur Cathéters Centraux',
      tooltip: `
<u>En réanimation adulte</u><br>
Taux d'incidence des bactériémies sur CVC, PICC et CDIA pour 1000 journées cathéters<br><br>
<u>En médecine, chirurgie, cancérologie et hématologie adulte</u><br>
Taux d'incidence des bactériémies sur CVC, CCI, PICC et CDIA pour 1000 journées d'hospitalisation complètes
`
    },

    'in-cvp': {
      title: 'Indicateur CVP court',
      tooltip: `
<u>Pour tous les services en secteur adulte</u><br>
Taux d'incidence des bactériémies sur CVP court pour 1000 journées d'hospitalisation complètes
`
    },

    'cvc-cci-picc-cdia': {
      title: 'CVC + CCI + PICC + CDIA'
    },

    'cvc-picc-cdia': {
      title: 'CVC + PICC + CDIA'
    },

    'cvc-picc-cvo': {
      title: 'CVC + PICC + CVO'
    }
  },

  pneu: {
    itb: {
      title: `Associées à l'intubation`,
      chartTitleFormat: () => `associées à l'intubation, `
    },
    pall: {
      title: 'Toutes pneumopathies',
      chartTitleFormat: () => `, `
    }
  }
}

function extractAllEntrances (type) {
  const result = []
  for (let d in entrances[type]) {
    result.push(
      {
        code: d,
        info: entrances[type][d]
      }
    )
  }

  return result
}

function extractEntrances (type, list, c) {
  let base = color(c)
  const result = []

  let alternateColor = false
  for (let i = 0; i !== list.length; ++i) {
    const l = list[i]

    if (l === '|') {
      alternateColor = !alternateColor
      continue
    }

    const item = {
      code: l,
      info: entrances[type][l],
      color: base,
      background: alternateColor ? '#a4dbe01A' : '#f9eca71A'
    }

    result.push(item)
    base = base.rotate(25)
  }

  return result
}

const indicatorsColors = extractEntrances(
  'bact', ['in-ctr', 'in-cvp'], '#E52A89'
)

function getColorFromCode (type) {
  return indicatorsColors.find(ic => ic.code === type)
}

const pdfEntrances = {
  bact: [
    [
      'in-ctr', 'in-cvp', 'ctr', 'cvc', 'cci', 'cvo', 'picc', 'caut', 'cart', 'cao', 'ecmo',
      'dia', 'cdia', 'fistnat', 'fistpro'
    ],
    [
      'peri', 'mid', 'midap', 'midsp', 'cvp', 'cvpap', 'cvpsp', 'nf', 'nfctr', 'nfperi',
      'all', 'sta', 'stakt', 'uri', 'urisa'
    ]
  ],

  pneu: [
    [ 'itb', 'pall' ]
  ]
}

const indicatorLimits = (function () {
  function buildIndicatorKey (
    infection, discId, speId, denominator, entrance
  ) {
    const discipline = discId === ''
      ? '__all__' : go.units.disciplines[discId].code
    const speciality = speId === ''
      ? '__all__' : go.units.specialities[speId].code
    return `${infection}.${discipline}.${speciality}.${denominator}.${entrance}`
  }

  const result = {}
  function add (key, value) {
    result[key] = value
  }

  add(
    buildIndicatorKey('bact', 'AdRea', '', 'kt', 'in-ctr'),
    {
      value: 1,
      title: `bactériémies liées à un CVC, PICC et CDIA
     pour 1000 journées cathéters en ${go.units.disciplines.AdRea.code}`,
      disc: 'Réanimation',
      ktType: 1,
      plot: {
        linkToPlot: true
      },
      spe: [
        buildIndicatorKey('bact', 'AdRea', 'AdReaAut', 'kt', 'in-ctr'),
        buildIndicatorKey('bact', 'AdRea', 'AdReaBru', 'kt', 'in-ctr'),
        buildIndicatorKey('bact', 'AdRea', 'AdReaCar', 'kt', 'in-ctr'),
        buildIndicatorKey('bact', 'AdRea', 'AdReaChir', 'kt', 'in-ctr'),
        buildIndicatorKey('bact', 'AdRea', 'AdReaMed', 'kt', 'in-ctr'),
        buildIndicatorKey('bact', 'AdRea', 'AdReaNeu', 'kt', 'in-ctr'),
        buildIndicatorKey('bact', 'AdRea', 'AdReaPol', 'kt', 'in-ctr')
      ]
    }
  )

  add(
    buildIndicatorKey('bact', 'AdHem', '', 'jhc', 'in-ctr'),
    {
      value: 2,
      title: `bactériémies liées à un CVC, CCI, PICC et CDIA
     pour 1000 journées d'hospitalisation complètes en ${go.units.disciplines.AdHem.code}`,
      disc: 'Hématologie',
      ktType: 1,
      plot: {
        linkToPlot: true
      }
    }
  )

  add(
    buildIndicatorKey('bact', 'AdCan', '', 'jhc', 'in-ctr'),
    {
      value: 2,
      title: `bactériémies liées à un CVC, CCI, PICC et CDIA
     pour 1000 journées d'hospitalisation complètes en ${go.units.disciplines.AdCan.code}`,
      disc: 'Cancérologie',
      ktType: 1,
      plot: {
        linkToPlot: true
      }
    }
  )

  add(
    buildIndicatorKey('bact', 'AdMed', '', 'jhc', 'in-ctr'),
    {
      value: 0.1,
      title: `bactériémies liées à un CVC, CCI, PICC et CDIA
     pour 1000 journées d'hospitalisation complètes en ${go.units.disciplines.AdMed.code}`,
      disc: 'Médecine',
      ktType: 1,
      plot: {
        linkToPlot: true
      }
    }
  )

  add(
    buildIndicatorKey('bact', 'AdChir', '', 'jhc', 'in-ctr'),
    {
      value: 0.1,
      title: `bactériémies liées à un CVC, CCI, PICC et CDIA
     pour 1000 journées d'hospitalisation complètes en ${go.units.disciplines.AdChir.code}`,
      disc: 'Chirurgie',
      ktType: 1,
      plot: {
        linkToPlot: true
      }
    }
  )

  add(
    buildIndicatorKey('bact', '', '', 'jhc', 'cvp'),
    {
      value: 0.1,
      title: `bactériémies liées à un CVP court pour 1000 journées d'hospitalisation complètes (tous les services)`,
      disc: 'Tous les services',
      ktType: 2,
      plot: {
        linkToPlot: false
      },
      pool: [
        buildIndicatorKey('bact', 'AdEhp', '', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdHad', '', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdMed', '', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdCan', '', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdHem', '', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdRad', '', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdObs', '', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdPsy', '', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdRea', '', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdUrg', '', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdSld', '', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdSsr', '', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdChir', '', 'jhc', 'in-cvp')
      ],
      spe: [
        buildIndicatorKey('bact', 'AdRea', 'AdReaAut', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdRea', 'AdReaBru', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdRea', 'AdReaCar', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdRea', 'AdReaChir', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdRea', 'AdReaMed', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdRea', 'AdReaNeu', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdRea', 'AdReaPol', 'jhc', 'in-cvp'),
        buildIndicatorKey('bact', 'AdMed', 'AdMedNep', 'jhc', 'in-cvp')
      ]
    }
  )
  return result
})()

const pooledIndicatorLimits = (function () {
  const result = {}
  for (let key in indicatorLimits) {
    const limit = indicatorLimits[key]
    if (limit.pool != null && limit.pool.length > 0) {
      for (let i = 0; i !== limit.pool.length; ++i) {
        const p = limit.pool[i]
        result[p] = limit.value
      }
    }

    if (limit.spe != null && limit.spe.length > 0) {
      for (let i = 0; i !== limit.spe.length; ++i) {
        const p = limit.spe[i]
        result[p] = limit.value
      }
    }
  }

  return result
})()

const expectedIndicators = Object.keys(indicatorLimits).length

const forbiddenKeyList = (function () {
  function checkKeys (c, reference, infection, list, text) {
    const infCategory = reference[infection]
    c.check(
      infCategory != null,
      `Invalid infection ${infection} in list ${text}`
    )
    if (infCategory == null) {
      return
    }

    for (let k in list) {
      const v = list[k]
      c.check(
        infCategory[v] != null,
        `Invalid ${text} ${v} for infection ${infection}`
      )
    }
  }

  const bact = 'bact'
  const ent = {
    caut: 'caut',
    all: 'all',
    urisa: 'urisa',
    peri: 'peri'
  }

  const den = {
    pat: 'pat',
    kt: 'kt',
    jh: 'jh',
    adm: 'adm',
    chi: 'chi',
    jhc: 'jhc',
    jhi: 'jhi'
  }
  const c = checker('@/sui/data/results/keyList')
  checkKeys(c, entrances, bact, ent, 'entrance')
  checkKeys(c, denominators, bact, den, 'denominator')
  c.end()

  return [
    {
      buildKey: (d) => `${d.inf}.${d.den}.${d.ent}`,
      targets: [
        new RegExp(
          `${bact}\\.(${den.kt}\\.(${ent.caut}|${ent.all})|${den.pat}\\.${ent.all}|(${den.jhc}|${den.jhi}|${den.adm})\\.${ent.urisa})`
        )
      ]
    },
    {
      buildKey: (d) => `${d.inf}.${d.den}.${d.ent}`,
      targets: [
        new RegExp(
          `${bact}\\.(${den.kt}|${den.pat})\\.${ent.peri}`
        )
      ]
    },
    {
      buildKey: (d) => d.den,
      targets: [
        new RegExp(`igs|${den.jh}$`)
      ]
    },
    {
      buildKey: (d) => `${d.uf ? d.uf : '__all__'}.${d.inf}.${d.den}.${d.disc}`,
      targets: [
        new RegExp(
          `__all__\\.${bact}\\.${den.chi}\\.(?!(${go.units.disciplines.AdHem.code}|${go.units.disciplines.AdCan.code}|${go.units.disciplines.AdRad.code}|${go.units.disciplines.PedCan.code}))`
        )
      ]
    }
  ]
})()

function getStatisticsKeyImpl (inf, disc, spe, den, ent) {
  const result = `${inf}.${disc}.${spe}.${den}.${ent}`
  assert(
    inf != null && disc != null && spe != null && den != null && ent != null,
    `Error getting statistics key: ${result}`
  )
  return result
}

function getStatisticsKey (r) {
  assert.notNull(r)
  return getStatisticsKeyImpl(r.inf, r.disc, r.spe, r.den, r.ent)
}

function getIncidenceKey (r) {
  assert.notNull(r)

  const result = `${getStatisticsKey(r)}.${r.uf}`
  assert.notNull(r.uf, `Error getting incidence key: ${result}`)
  return result
}

function getEstablishementType (t) {
  for (let i in establishments) {
    const e = establishments[i]
    if (e.values.indexOf(t) !== -1) {
      return i
    }
  }

  return null
}

function getEstablishementTypes () {
  const result = []
  for (let i in establishments) {
    const e = establishments[i]
    result.push({ code: i, value: e.title })
  }
  return result
}

function getMaternityType (m) {
  for (let i in establishments) {
    const e = establishments[i]
    if (e.maternityType != null && e.maternityType === m) {
      return i
    }
  }

  return null
}

function splitStatisticsKey (k) {
  assert.notNull(k)
  assert.isString(k)
  const values = k.split('.')
  assert(values.length >= 4, values)

  return {
    inf: values[0],
    disc: values[1],
    spe: values[2],
    den: values[3],
    ent: values[4]
  }
}

function incidenceKeyToStatisticsKey (k) {
  assert.notNull(k)
  return getStatisticsKey(splitStatisticsKey(k))
}

function isForbidden (d) {
  assert(
    d != null && d.inf != null && d.den != null &&
      d.disc != null && d.ent != null && d.spe != null
  )

  const data = clone(d)
  if (data.uf == null) {
    data.uf = '__all__'
  }

  for (let i = 0; i < forbiddenKeyList.length; i++) {
    const forbiddenData = forbiddenKeyList[i]
    const key = forbiddenData.buildKey(d)
    const forbiddenKeys = forbiddenData.targets

    for (let j = 0; j !== forbiddenKeys.length; ++j) {
      const r = forbiddenKeys[j]
      if (key.match(r)) {
        return true
      }
    }
  }
  return false
}

function flattenStatistics (values, forbidden) {
  const result = {}
  for (let k in values) {
    const d = values[k]

    if (forbidden && isForbidden(d)) {
      continue
    }

    const key = getStatisticsKey(
      { inf: d.inf, disc: d.disc, spe: d.spe, den: d.den, ent: d.ent }
    )
    if (result[key] == null) {
      result[key] = {}
    }

    const type = d.r == null || d.r === '' ? d.t : `${d.r}.${d.t}`

    const value = {
      s: d.s,
      num: d.num,
      div: d.div,
      pop: d.pop
    }

    if (d.num != null && d.div != null && d.div !== 0) {
      const [info, ok] = go.denom.info(d.den, d.inf)
      if (!ok) {
        continue
      }

      const factor = info.Factor
      if (factor == null) {
      }
      value.meanp = factor * d.num / d.div
      value.factor = factor
    }

    result[key][type] = value
  }

  return result
}

function getIndicatorLimit (inf, disc, spe, ent, den) {
  const key = getStatisticsKeyImpl(inf, disc, spe, den, ent)
  return getIndicatorLimitFromKey(key)
}

function getIndicatorLimitFromKey (key) {
  let l = indicatorLimits[key]

  if (l != null) {
    return l.value
  }

  return pooledIndicatorLimits[key]
}

function flattenIncidences (forbidden, values, type, freeze = true) {
  assert.isArray(values)

  const result = {
    empty: false,
    type: type,
    units: {},
    unitList: {},
    completeUnitList: [],
    specialities: [],
    values: {}
  }

  try {
    for (let j = 0; j !== values.length; ++j) {
      const i = values[j]

      if (i.mod !== '__all__') {
        continue
      }

      if (forbidden && isForbidden(i)) {
        continue
      }

      const incidences = [i]
      if (i.spe !== '__all__' && i.uf !== '__all__' && i.uf !== '__spe__') {
        incidences.push(
          {
            den: i.den,
            disc: i.disc,
            div: i.div,
            ent: i.ent,
            inc: i.inc,
            inf: i.inf,
            mean: i.mean,
            mod: i.mod,
            num: i.num,
            qua: 4,
            spe: '__all__',
            uf: i.uf
          }
        )
      }

      for (let k = 0; k !== incidences.length; ++k) {
        const source = incidences[k]

        const key = getStatisticsKey(source)
        const criteria = `${key}.${i.uf}`

        assert.isNull(result.values[criteria])
        const incidence = {
          incidence: source.inc,
          quality: source.qua,
          mean: source.mean
        }

        if (source.div != null && source.div > 0) {
          incidence.divisor = source.div
          incidence.numerator = source.num
        }
        result.values[criteria] = incidence

        const speindex = result.specialities.indexOf(source.spe)
        if (speindex === -1) {
          result.specialities.push(source.spe)
        }

        if (result.units[source.inf] == null) {
          result.units[source.inf] = {}
        }

        let array = result.units[source.inf][source.den]
        if (array == null) {
          array = []
          result.units[source.inf][source.den] = array
        }

        let unit = result.completeUnitList.find(
          u => u.disc === source.disc &&
            u.spe === source.spe &&
            u.uf === source.uf
        )
        if (unit == null) {
          unit = source
          result.completeUnitList.push(unit)
        }

        if (result.unitList[source.inf] == null) {
          result.unitList[source.inf] = []
        }
        const index = result.unitList[source.inf].indexOf(unit)
        if (index === -1) {
          result.unitList[source.inf].push(unit)
          array.push(unit)
        } else if (array.indexOf(unit) === -1) {
          array.push(unit)
        }
      }
    }

    result.specialities.sort()
    for (let t in result.units) {
      for (let d in result.units[t]) {
        result.units[t][d].sort(
          (f, s) => {
            let compare = f.disc.localeCompare(s.disc)
            if (compare !== 0) {
              return compare
            }
            compare = f.spe.localeCompare(s.spe)
            if (compare !== 0) {
              return compare
            }
            return f.uf.localeCompare(s.uf)
          }
        )
      }
    }
  } catch (e) {
    // console.log(e)
  }
  return freeze ? ice.freeze(result) : result
}

function createOrPoolIndicator (num, den, result, factor) {
  if (result.incidence == null &&
      result.numerator == null &&
      result.divisor == null &&
      result.quality == null &&
      result.mean == null
  ) {
    return {
      numerator: num,
      divisor: den,
      incidence: num / den * factor,
      quality: 0,
      mean: -1
    }
  }

  result.numerator += num
  result.divisor += den
  result.incidence = result.numerator / result.divisor * factor
  return result
}

function getInciData (d, single) {
  if (d == null) {
    return [null, null, null, null]
  }
  if (single) {
    return [d.incidence, d.divisor, d.numerator, null]
  }
  return [d.meanp, d.div, d.num, d.pop]
}

function countInTarget (pop, l) {
  let c = 0
  let total = pop.length
  for (let j = 0; j !== total; ++j) {
    if (pop[j] <= l) {
      ++c
    }
  }
  return [c, total]
}

function createIndicator (key, d, indSetup, single) {
  const [ incidence, divisor, numerator, pop ] = getInciData(d, single)
  const { inf, disc, spe, den, ent } = splitStatisticsKey(key)

  const target = indSetup.value
  indSetup.plot.den = extractedDen.bact.find(d => d.code === den)

  if (incidence == null ||
      numerator == null ||
      divisor == null
  ) {
    return {
      incidence: null,
      title: indSetup.title,
      disc: indSetup.disc,
      ktType: indSetup.ktType,
      plot: indSetup.plot,
      limit: target,
      valid: null
    }
  }

  const isInTarget = incidence <= target
  let popDetail = null
  if (pop) {
    const [estbInTarget, estbTotal] = countInTarget(pop, target)
    popDetail = {
      inTarget: estbInTarget,
      total: estbTotal
    }
  }

  indSetup.plot.l = {
    inf: inf,
    disc: disc,
    spe: spe,
    uf: '__all__',
    den: den,
    ent: ent
  }
  indSetup.plot.color = getColorFromCode(ent)
  indSetup.plot.infType = infectionTypes[0]
  indSetup.plot.den = extractedDen.bact.find(d => d.code === den)

  return {
    incidence: {
      incidence: incidence,
      den: den,
      divisor: divisor,
      numerator: numerator,
      popDetail: popDetail
    },
    title: indSetup.title,
    disc: indSetup.disc,
    ktType: indSetup.ktType,
    plot: indSetup.plot,
    limit: target,
    valid: isInTarget
  }
}

function getIndicatorData (values, key, extendKey, type) {
  if (values == null || key == null) {
    return null
  }

  let data = values[key]
  if (extendKey) {
    data = values[`${key}.${extendKey}`]
  }

  if (type && data) {
    return data[type]
  }

  return data
}

function countFailedIndicators (ind, fail) {
  if (ind == null || isNaN(ind.incidence)) {
    fail++
  }
  return fail
}

function computeIndicators (values, type) {
  if (values == null) {
    return null
  }

  let extKeyInd = null
  const isSingleEstb = type == null
  if (isSingleEstb) {
    extKeyInd = '__all__'
  }

  let singleIndicators = {}
  let pooledIndicators = {}
  let fail = 0

  for (let i in indicatorLimits) {
    const indicatorData = getIndicatorData(values, i, extKeyInd, type)
    const indicatorSetup = indicatorLimits[i]
    const pool = indicatorSetup.pool

    if (pool == null) {
      const idRes = createIndicator(i, indicatorData, indicatorSetup, isSingleEstb)
      fail = countFailedIndicators(idRes.incidence, fail)
      singleIndicators[i] = idRes
    } else if (pool && isSingleEstb) {
      let pooledCount = 0
      const key = splitStatisticsKey(i)
      const [info, ok] = go.denom.info(key.den, key.inf)
      if (!ok) {
        continue
      }

      const factor = info.Factor
      for (let j in pool) {
        const key = pool[j]
        const indicatorData = getIndicatorData(values, key, extKeyInd, type)

        if (indicatorData) {
          pooledCount++
          pooledIndicators = createOrPoolIndicator(
            indicatorData.numerator,
            indicatorData.divisor,
            pooledIndicators,
            factor
          )
        }
      }

      if (pooledCount > 0) {
        const idRes = createIndicator(i, pooledIndicators, indicatorSetup, isSingleEstb)
        fail = countFailedIndicators(idRes.incidence, fail)
        singleIndicators[i] = idRes
      }
    }
  }

  if (expectedIndicators === fail) {
    return {}
  }
  return singleIndicators
}

function flattenIndicators (values, type) {
  const table = {
    key: 'indicator',
    open: true,
    title: 'Indicateurs (Distribution des établissements en fonction des seuils des indicateurs)',
    list: []
  }
  const dist = {}

  for (let i in indicatorLimits) {
    const v = values[i]
    if (v == null || v[type] == null) {
      continue
    }

    const l = indicatorLimits[i].value
    if (l.pool !== undefined) {
      continue
    }

    const pop = v[type].pop
    const [c, total] = countInTarget(pop, l)

    dist[i] = {
      type: 'rep',
      total: pop.length,
      values: {
        '1': c,
        '2': total - c
      }
    }

    table.list.push(
      {
        f: i,
        t: indicatorLimits[i].title,
        v: [
          { code: 1, value: `Taux d'incidence <= ${l}` },
          { code: 2, value: `Taux d'incidence > ${l}` }
        ]
      }
    )
  }
  return {
    tables: [table],
    dist: dist
  }
}

function check () {
  const c = checker('@/sui/data/results')

  c.checkSchemas(
    'qualities',
    qualities,
    [
      { key: 'color', req: true, type: 'color' },
      { key: 'opacity', req: true, type: 'percent' }
    ]
  )

  const denomSchema = [
    { key: 'label', req: true, type: 'str' },
    { key: 'short', type: 'str' },
    { key: 'unit', req: true, type: 'str' },
    {
      key: 'year',
      type: 'pint',
      check: { f: (f) => f >= 2019, msg: 'expected value >= 2019' }
    }
  ]

  c.checkSchemas(
    'bact denominators',
    denominators.bact,
    denomSchema
  )

  c.checkSchemas(
    'pneu denominators',
    denominators.pneu,
    denomSchema
  )

  const entrancesSchema = [
    { key: 'title', req: true, type: 'str' },
    { key: 'short', type: 'str' },
    { key: 'tooltip', type: 'str' },
    { key: 'chartTitleFormat', type: 'func' },
    {
      key: 'year',
      type: 'pint',
      check: { f: (f) => f >= 2019, msg: 'expected value >= 2019' }
    }
  ]

  c.checkSchemas(
    'bact entrances',
    entrances.bact,
    entrancesSchema
  )

  c.checkSchemas(
    'pneu entrances',
    entrances.pneu,
    entrancesSchema
  )

  for (let i = 0; i !== pdfEntrances.bact.length; ++i) {
    const list = pdfEntrances.bact[i]
    for (let j = 0; j !== list.length; ++j) {
      const v = list[j]
      c.check(
        entrances.bact[v] != null,
        `pdf: unknown entrance for bacteremia (${v})`
      )
    }
  }

  for (let i = 0; i !== pdfEntrances.pneu.length; ++i) {
    const list = pdfEntrances.pneu[i]
    for (let j = 0; j !== list.length; ++j) {
      const v = list[j]
      c.check(
        entrances.pneu[v] != null,
        `pdf: unknown entrance for pneumopathy (${v})`
      )
    }
  }

  const forbiddenKeys = [
    { inf: 'bact', den: 'igs', ent: 'all', disc: '', spe: '', uf: '' },
    { inf: 'bact', den: 'jh', ent: 'all', disc: '', spe: '', uf: '' },
    { inf: 'bact', den: 'kt', ent: 'caut', disc: '', spe: '', uf: '' },
    { inf: 'bact', den: 'kt', ent: 'all', disc: '', spe: '', uf: '' },
    { inf: 'bact', den: 'kt', ent: 'peri', disc: '', spe: '', uf: '' },
    { inf: 'bact', den: 'pat', ent: 'all', disc: '', spe: '', uf: '' },
    { inf: 'bact', den: 'jh', ent: 'cvc', disc: '', spe: '', uf: '' },
    { inf: 'bact', den: 'jhc', ent: 'urisa', disc: '', spe: '', uf: '' },
    { inf: 'bact', den: 'jhi', ent: 'urisa', disc: '', spe: '', uf: '' },
    { inf: 'bact', den: 'adm', ent: 'urisa', disc: '', spe: '', uf: '' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD MED', spe: '__all__', uf: '__all__' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'PED MED', spe: '__all__', uf: '__all__' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD REA', spe: '__all__', uf: '__all__' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD DIA', spe: '__all__', uf: '__all__' }
  ]

  for (let i = 0; i !== forbiddenKeys.length; ++i) {
    const key = forbiddenKeys[i]
    c.check(
      isForbidden(key),
      `${Object.values(key).join('.')} should be forbidden`
    )
  }

  const allowedKeys = [
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD CAN', spe: '__all__', uf: '__all__' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD CAN', spe: 'AD CAN', uf: '__all__' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD CAN', spe: 'AD CAN', uf: 'test' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD HEM', spe: '__all__', uf: '__all__' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD HEM', spe: 'AD HEM', uf: '__all__' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD HEM', spe: 'AD HEM', uf: 'test' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD RAD', spe: '__all__', uf: '__all__' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD RAD', spe: 'AD RAD', uf: '__all__' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD RAD', spe: 'AD RAD', uf: 'test' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'PED CAN', spe: '__all__', uf: '__all__' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'PED CAN', spe: 'PED CAN', uf: '__all__' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'PED CAN', spe: 'PED CAN', uf: 'test' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD MED', spe: '__all__', uf: 'test' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD MED', spe: 'AD MED JOU', uf: 'test' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD REA', spe: '__all__', uf: 'test' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD REA', spe: 'AD REA POL', uf: 'test' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD DIA', spe: '__all__', uf: 'test' },
    { inf: 'bact', den: 'chi', ent: '', disc: 'AD DIA', spe: 'AD DIA UDM', uf: 'test' }
  ]

  for (let i = 0; i !== allowedKeys.length; ++i) {
    const key = allowedKeys[i]
    c.check(
      !isForbidden(key),
      `${Object.values(key).join('.')} should not be forbidden`
    )
  }

  for (let k in indicatorLimits) {
    const limit = indicatorLimits[k]
    c.checkSchema(
      `indicatorLimits[${k}]`,
      limit,
      [
        { key: 'value', req: true, type: 'num' },
        { key: 'title', req: true, type: 'str' },
        { key: 'spe', type: 'array' },
        { key: 'pool', type: 'array' }
      ]
    )

    const keys = [k]
    if (limit.spe) {
      keys.push(...limit.spe)
    }
    if (limit.pool) {
      keys.push(...limit.pool)
    }

    for (let i = 0; i !== keys.length; ++i) {
      const key = splitStatisticsKey(keys[i])
      const inf = key.inf === 'bact' || key.inf === 'pneu'
      c.check(
        inf,
        `indicatorLimits[${k}]: unknown infection ${key.inf}`
      )
      if (!inf) {
        continue
      }

      c.check(
        denominators[key.inf][key.den] != null,
        `indicatorLimits[${k}]: unknown denominator ${key.den}`
      )
      c.check(
        entrances[key.inf][key.ent] != null,
        `indicatorLimits[${k}]: unknown entrance ${key.ent}`
      )

      if (key.disc !== '__all__') {
        for (let y in units) {
          const disc = Object.values(units[y].disc).find(d => d.code === key.disc)
          c.check(
            disc != null,
            `indicatorLimits[${k}]: unknown discipline ${key.disc} in ${y}`
          )

          if (disc != null && key.spe !== '__all__') {
            c.check(
              disc.list.find(s => s.code === key.spe),
              `indicatorLimits[${k}]: unknown speciality ${key.spe} for discipline ${key.disc} in ${y}`
            )
          }
        }
      }
    }
  }

  c.checkSchemas(
    'establishment types',
    establishments,
    [
      { key: 'title', req: true, type: 'str' },
      {
        key: 'values',
        req: true,
        type: 'array',
        sub: { req: true, type: 'pint' }
      },
      { key: 'graphTitle', type: 'str' },
      {
        key: 'maternityType',
        type: 'pint',
        check: {
          f: (m) => m >= 1 && m <= 4,
          msg: 'expected value between 1 and 4.'
        }
      }
    ]
  )

  c.end()
}

function orElse (obj, field, e) {
  return obj != null && obj[field] != null ? obj[field] : e
}

function fixDecimals (value, arg = {}) {
  const minimize = orElse(arg, 'minimizeDecimalScale', false)
  if (!minimize) {
    return value.toFixed(3)
  }

  const scale = orElse(arg, 'scale', 3)
  const decimalCount = math.countDigits(value).decimals
  return value.toFixed(
    decimalCount < scale ? decimalCount : scale
  )
}

const microOrganismsGroups = (function () {
  const all = {
    index: 0,
    name: `Tous les micro-organismes`
  }

  const groupList = [
    {
      index: 1,
      name: `<i>Staphylococcus aureus</i>`,
      list: [0]
    },
    {
      index: 2,
      name: `Autres staphylocoques`,
      list: [1, 2, 3, 4, 5]
    },
    {
      index: 3,
      name: `Tous les stréptocoques`,
      list: [6, 7, 8, 9, 10, 11]
    },
    {
      index: 4,
      name: `Tous les entérocoques`,
      list: [12, 13, 14, 15]
    },
    {
      index: 5,
      name: `Tous les bacillus`,
      list: [22, 23]
    },
    {
      index: 6,
      name: `Tous les citrobacter`,
      list: [27, 28, 29]
    },
    {
      index: 7,
      name: `Tous les enterobacter`,
      list: [30, 31, 32]
    },
    {
      index: 8,
      name: `Toutes les klebsiella`,
      list: [35, 36, 37]
    },
    {
      index: 9,
      name: `Toutes les serratia`,
      list: [44]
    },
    {
      index: 10,
      name: `Toutes les entérobactérales`,
      list: [27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46]
    },
    {
      index: 11,
      name: `Tous les achromobacter`,
      list: [47]
    },
    {
      index: 12,
      name: `Tous les acinetobacter`,
      list: [48, 49]
    },
    {
      index: 13,
      name: `<i>Pseudomonas aeruginosa</i>`,
      list: [61]
    },
    {
      index: 14,
      name: `Candida, Levures et Filamenteux`,
      list: [79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89]
    },
    {
      index: 15,
      name: `<i>Staphylococcus epidermidis</i>`,
      list: [1]
    },
    {
      index: 16,
      name: `<i>Staphylococcus haemolyticus</i>`,
      list: [2]
    },
    {
      index: 17,
      name: `<i>Staphylococcus capitis</i>`,
      list: [3]
    },
    {
      index: 18,
      name: `<i>Streptococcus pyogenes</i> (A)`,
      list: [8]
    },
    {
      index: 19,
      name: `<i>Streptococcus agalactiae</i> (B)`,
      list: [7]
    },
    {
      index: 20,
      name: `<i>Escherichia coli</i>`,
      list: [33]
    }
  ]

  const byIndex = {
    0: all
  }
  for (let i = 0; i !== groupList.length; ++i) {
    const group = groupList[i]
    byIndex[group.index] = group
  }

  return {
    groupList,
    byIndex,

    filterSheets: function (infectionList, group) {
      if (group.list == null) {
        return infectionList
      }

      const result = []
      const allowed = new Set(group.list)
      for (let i = 0; i !== infectionList.length; ++i) {
        const infection = infectionList[i]
        const moList = infection.inf.microOrganisms
        for (let k = 0; k !== moList.length; ++k) {
          const mo = moList[k]
          if (allowed.has(mo.code)) {
            result.push(infection)
            break
          }
        }
      }
      return result
    },

    getAvailableGroups: function (infectionLists) {
      if (infectionLists == null) {
        return []
      }

      assert.isArray(infectionLists)
      const unique = new Set()
      for (let i = 0; i !== infectionLists.length; ++i) {
        const infectionList = infectionLists[i]
        if (infectionList == null) {
          continue
        }

        for (let j = 0; j !== infectionList.length; ++j) {
          const infection = infectionList[j]
          const moList = infection.inf.microOrganisms
          for (let k = 0; k !== moList.length; ++k) {
            const mo = moList[k]
            unique.add(mo.code)
          }
        }
      }

      if (unique.size === 0) {
        return []
      }

      const result = [all]
      for (let i = 0; i !== groupList.length; ++i) {
        const group = groupList[i]
        for (let j = 0; j !== group.list.length; ++j) {
          const mo = group.list[j]
          if (unique.has(mo)) {
            result.push(group)
            break
          }
        }
      }

      result.sort((f, s) => f.index > s.index)
      return result
    }
  }
})()

export default {
  qualities: qualities,
  fixDecimals,
  denominators: denominators,
  establishments: establishments,
  entrances: entrances,
  pdf: pdfEntrances,

  specialities: function (year) {
    return units[year].specialities
  },

  getEstablishementType,
  getEstablishementTypes,
  getMaternityType,
  getStatisticsKey,
  getIncidenceKey,
  splitStatisticsKey,
  incidenceKeyToStatisticsKey,
  getIndicatorLimit,
  getIndicatorLimitFromKey,

  flattenStatistics,
  flattenIncidences,
  flattenIndicators,
  computeIndicators,
  getktTypeData,
  infectionTypes: infectionTypes,
  extractEntrances: extractEntrances,
  extractAllEntrances: extractAllEntrances,
  extractDenominators: extractDenominators,
  check,
  microOrganismsGroups,
  getDecimalsOptions: function (d, minimizeDecimalScale) {
    return {
      minimizeDecimalScale: minimizeDecimalScale,
      scale: d
    }
  }
}
